module.exports = __webpack_public_path__ + "assets/img/btn-detail-26f7113b.png";